// BUSINESS DESK — profil entreprise : identité, logo (partagé par les 3 activités), activités.
import { useState } from "react";
import { toast } from "sonner";
import { deskApi } from "./deskApi";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function DeskProfile({ profile, onRefresh, onLock }) {
  const [form, setForm] = useState({
    legal_name: profile.legal_name || "",
    display_name: profile.display_name || "",
    address: profile.address || "",
    phone: profile.phone || "",
    email: profile.email || "",
  });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await deskApi("/profile", { method: "PUT", body: form });
      toast.success("Profil enregistré ✓");
      onRefresh();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const uploadLogo = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        await deskApi("/profile/logo", { method: "POST", body: { data_url: reader.result } });
        toast.success("Logo mis à jour ✓");
        onRefresh();
      } catch (e) { toast.error(e.message); }
    };
    reader.readAsDataURL(file);
  };

  const toggleActivity = async (a) => {
    try {
      await deskApi(`/activities/${a.activity_id}`, { method: "PUT", body: { active: !a.active } });
      onRefresh();
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div data-testid="desk-profile">
      <div className="desk-section-title">Logo (partagé par les 3 activités)</div>
      <div className="desk-card" style={{ display: "flex", alignItems: "center", gap: 14 }}>
        {profile.logo_url
          ? <img src={`${API}${profile.logo_url}`} alt="logo" className="desk-header-logo" style={{ width: 64, height: 64 }} data-testid="desk-logo-img" />
          : <div className="desk-header-logo-ph" style={{ width: 64, height: 64, fontSize: 26 }}>{(form.display_name || "E").charAt(0)}</div>}
        <label className="desk-btn desk-btn-outline desk-btn-sm" style={{ cursor: "pointer" }}>
          📷 {profile.logo_url ? "Changer le logo" : "Ajouter le logo"}
          <input type="file" accept="image/jpeg,image/png,image/webp" data-testid="desk-logo-input" style={{ display: "none" }} onChange={(e) => uploadLogo(e.target.files?.[0])} />
        </label>
      </div>

      <div className="desk-section-title">Mon entreprise</div>
      <div className="desk-card">
        <div className="desk-field"><label>Nom commercial *</label>
          <input className="desk-input" data-testid="desk-profile-display-input" value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} /></div>
        <div className="desk-field"><label>Raison sociale *</label>
          <input className="desk-input" data-testid="desk-profile-legal-input" value={form.legal_name} onChange={(e) => setForm({ ...form, legal_name: e.target.value })} /></div>
        <div className="desk-field"><label>Adresse</label>
          <input className="desk-input" data-testid="desk-profile-address-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
        <div className="desk-row2">
          <div className="desk-field"><label>Téléphone</label>
            <input className="desk-input" data-testid="desk-profile-phone-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
          <div className="desk-field"><label>Email</label>
            <input className="desk-input" data-testid="desk-profile-email-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
        </div>
        <button className="desk-btn desk-btn-gold" style={{ marginTop: 16 }} data-testid="desk-profile-save-btn" disabled={busy || !form.display_name.trim() || !form.legal_name.trim()} onClick={save}>
          Enregistrer
        </button>
      </div>

      <div className="desk-section-title">Mes activités</div>
      <div className="desk-card">
        {(profile.activities || []).map((a) => (
          <div key={a.activity_id} className="desk-line" style={{ borderBottom: "none" }}>
            <span className="dl-desc">{a.icon} {a.name}</span>
            <button
              className={`desk-chip ${a.active ? "on" : ""}`}
              data-testid={`desk-activity-toggle-${a.activity_id}`}
              onClick={() => toggleActivity(a)}
            >
              {a.active ? "Active ✓" : "Inactive"}
            </button>
          </div>
        ))}
      </div>

      <button className="desk-btn desk-btn-outline" style={{ marginTop: 20 }} data-testid="desk-lock-now-btn" onClick={onLock}>
        🔒 Verrouiller le Business Desk
      </button>
      <p className="desk-note">⚖️ Les mentions légales (TVA, RCCM, règles export UE) doivent être validées par votre conseil avant usage officiel des documents.</p>
    </div>
  );
}
